import { DOCUMENT, Service, inject } from '@angular/core';

import { DeviceService } from '@nbx/core/device';

@Service()
export class EncryptionService {
  private readonly _document: Document;

  private readonly _deviceService: DeviceService;

  private _window?: Window;

  constructor() {
    this._document = inject<Document>(DOCUMENT);
    this._deviceService = inject(DeviceService);
    if (this._deviceService.isBrowser()) {
      this._window = this._document.defaultView as Window & { JSON: JSON };
    }
  }

  encrypt(value: string): string {
    if (value && this._deviceService.isBrowser() && this._window) {
      return this._window.btoa(value);
    }
    return '';
  }

  decrypt(encryptedValue: string): string {
    if (encryptedValue && this._deviceService.isBrowser() && this._window) {
      return this._window.atob(encryptedValue);
    }
    return '';
  }
}
